import { render, staticRenderFns } from "./sessionArchiv.vue?vue&type=template&id=707b2ad2&scoped=true"
import script from "./sessionArchiv.vue?vue&type=script&lang=js"
export * from "./sessionArchiv.vue?vue&type=script&lang=js"
import style0 from "./sessionArchiv.vue?vue&type=style&index=0&id=707b2ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b2ad2",
  null
  
)

export default component.exports